export const generateSiteName = () => {
  const digits = Array.from({ length: 10 }, () => Math.floor(Math.random() * 10)).join('');
  return `Site-${digits}`;
};
